const E = {
  title: 'Customer Portal Login',
  sub: 'Secure access to your results and more',
  form: {
    region: {
      label: 'Region',
      error: 'Please select a region',
    },
    email: {
      label: 'Email Address',
      error: 'Invalid email format',
    },
    buttons: {
      submit: 'submit',
      cancel: 'cancel',
      return: 'Return to login',
    },
  },
  links: {
    resend: 'Resend email',
  },
};

const F = {
  title: 'Connexion au Portail Client',
  sub: 'Accès sécurisé à vos résultats et plus encore',
  form: {
    region: {
      label: 'Région',
      error: 'Veuillez choisir une région',
    },
    email: {
      label: 'Adresse courriel',
      error: 'Le format de l’adresse de courrier électronique est inexact',
    },
    buttons: {
      submit: 'Soumettre',
      cancel: 'Annuler',
      return: 'Revenir à la page de connexion',
    },
  },
  links: {
    resend: 'Renvoyer le courriel',
  },
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/forgot.js